import React from 'react'
import { Routes, Route, } from 'react-router-dom';
import Landing from '../features/landing/landing';
import Destinations from '../features/destinations/destinations';
import Services from '../features/services/services';
import Parcels from '../features/parcels/parcels';
import Offers from '../features/offers/offers';
import ContactUs from '../features/contact-us/contact-us';
import ChangeDestiny from '../features/change-destiny/change-destiny';
import SalesProcess from '../features/sales-process/sales-process';
import PaymentFinish from '../features/payment-finish/payment-finish';
import ServicesDetails from '../features/service-details/service-details';
import ParcelSearch from '../features/parcel-search/parcel-search';
import FrequentQuestions from '../features/frequent-questions/frequent-questions';
import ComplaintsBook from '../features/complaints-book/complaints-book';
import MyAccount from '../features/my-account/my-account';
import PrivacyPolicies from '../features/privacy-policies/privacy-policies';
import TermsConditions from '../features/terms-conditions/terms-conditions';
import AboutUs from '../features/about-us/about-us';
import OffersDetail from '../features/offers-detail/offers-detail';
import Login from './auth/login/login';

function App() {
  return (
    <Routes>
      {/* Pages */}
      <Route path='/' element={<Landing />} />
      <Route path='/login' element={<Login />} />
      <Route path='/destinos' element={<Destinations />} />
      <Route path='/servicios' element={<Services />} />
      <Route path='/encomiendas' element={<Parcels />} />
      <Route path='/promociones' element={<Offers />} />
      <Route path='/contactanos' element={<ContactUs />} />
      <Route path='/mi-cuenta' element={<MyAccount />} />
      <Route path='/nosotros' element={<AboutUs />} />
      <Route path='/politicas-de-privacidad' element={<PrivacyPolicies />} />
      <Route path='/terminos-y-condiciones' element={<TermsConditions />} />

      {/* SubPages */}
      <Route path='/destinos/chiclayo' element={<ChangeDestiny />} />
      <Route path='/promociones/chiclayo' element={<OffersDetail />} />
      <Route path='/servicios/detalle' element={<ServicesDetails />} />
      <Route path='/proceso-venta' element={<SalesProcess />} />
      <Route path='/pago-exitoso' element={<PaymentFinish />} />
      <Route path='/busqueda-encomiendas' element={<ParcelSearch />} />
      <Route path='/preguntas-frecuentes' element={<FrequentQuestions />} />
      <Route path='/libro-de-reclamaciones' element={<ComplaintsBook />} />

      {/* 404 */}
      <Route path='/*' element={<>Página no encontrada</>} />
    </Routes>
  );
}

export default App;
